import { render, staticRenderFns } from "./ShoppingConfirmed.vue?vue&type=template&id=30e10aaa&scoped=true&"
import script from "./ShoppingConfirmed.vue?vue&type=script&lang=js&"
export * from "./ShoppingConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e10aaa",
  null
  
)

export default component.exports